/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { EpCheckboxGroup } from '../../../../components/EpCheckboxGroup';
import { EpCheckbox } from '../EpCheckbox';
import { EpErrorMessage } from '../EpErrorMessage';
import { useFormContext } from 'react-hook-form';

type QuestionsAnswersProps = {
  questionId: number;
  questionDescription: string;
  required: boolean;
  maxLength: number;
  questionReferLibraryId: number;
  questionTypeId: number;
  questionsLibrary: boolean;
  questionCategoryIncident: number;
  order: number;
  answerRequiredId: number | null;
  questionRequiredId: number | null;
  answers?: {
    answerId: number;
    answerDescription: string;
  }[];
};

const EpQuestionCheckbox = ({
  QuestionsAnswers,
  index,
}: {
  QuestionsAnswers: QuestionsAnswersProps;
  index: number;
}) => {
  const controller = `questions.${index}`;
  const { formState: { errors } } = useFormContext();

  // const takeErrors = () => {
  //   if (!errors) return false
  //   if (errors && !errors['questions']) return false
  //   if (errors && (errors['questions'] as any)?.length > Number(index) + 1) return false

  //   return   console.log(!!errors['questions']?.[index], controller, errors)
  // }

  return (
    <>
      <EpCheckboxGroup legend={`${QuestionsAnswers.questionDescription} ${QuestionsAnswers.required ? '*' : ''}`}>
        {QuestionsAnswers.answers?.map((answer) => (
          <EpCheckbox
            key={answer.answerId}
            checkboxValue={answer.answerId.toString()}
            checkboxName={controller}
            checkboxLabel={answer.answerDescription}
            required={QuestionsAnswers.required}
            checkboxWithError={!!(errors['questions'] as any)?.[index]}
          />
        ))}
      </EpCheckboxGroup>
      <EpErrorMessage inputName={controller} />
    </>
  );
};

export default memo(EpQuestionCheckbox);
